/* ============================================
   Greenhouse Girls — Global Animations
   1. Upload to assets folder
   2. Add in theme.liquid before </body>:
      {{ 'gs-animations.js' | asset_url | script_tag }}
   ============================================ */

(function () {
  'use strict';

  /* ── Inject keyframes + animation classes ── */
  var style = document.createElement('style');
  style.textContent = `
    @keyframes gs-fade-up {
      from { opacity: 0; transform: translateY(40px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes gs-fade-down {
      from { opacity: 0; transform: translateY(-40px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes gs-fade-left {
      from { opacity: 0; transform: translateX(50px); }
      to   { opacity: 1; transform: translateX(0); }
    }
    @keyframes gs-fade-right {
      from { opacity: 0; transform: translateX(-50px); }
      to   { opacity: 1; transform: translateX(0); }
    }
    @keyframes gs-zoom-in {
      from { opacity: 0; transform: scale(0.9); }
      to   { opacity: 1; transform: scale(1); }
    }

    [data-gs-anim] {
      opacity: 0;
      will-change: transform, opacity;
    }
    [data-gs-anim].gs-animated {
      opacity: 1;
    }
    [data-gs-anim="fade-up"].gs-animated {
      animation: gs-fade-up 0.75s cubic-bezier(0.22,1,0.36,1) both;
    }
    [data-gs-anim="fade-down"].gs-animated {
      animation: gs-fade-down 0.75s cubic-bezier(0.22,1,0.36,1) both;
    }
    [data-gs-anim="fade-left"].gs-animated {
      animation: gs-fade-left 0.75s cubic-bezier(0.22,1,0.36,1) both;
    }
    [data-gs-anim="fade-right"].gs-animated {
      animation: gs-fade-right 0.75s cubic-bezier(0.22,1,0.36,1) both;
    }
    [data-gs-anim="zoom-in"].gs-animated {
      animation: gs-zoom-in 0.75s cubic-bezier(0.22,1,0.36,1) both;
    }

    [data-gs-delay="100"].gs-animated { animation-delay: 0.1s; }
    [data-gs-delay="200"].gs-animated { animation-delay: 0.2s; }
    [data-gs-delay="300"].gs-animated { animation-delay: 0.3s; }
    [data-gs-delay="400"].gs-animated { animation-delay: 0.4s; }
    [data-gs-delay="500"].gs-animated { animation-delay: 0.5s; }
    [data-gs-delay="600"].gs-animated { animation-delay: 0.6s; }

    /* ── Button hover — dark green bg, white text ── */
    .cs_banner_content_button,
    .cs-feel-card__btn,
    .lm-card__direction,
    .cp-card__btn {
      transition: background 0.35s ease, color 0.35s ease !important;
    }

    .cs_banner_content_button:hover {
      background: rgba(10, 24, 10, 0.9) !important;
      color: #fff !important;
    }

    /* white bg buttons — dark green fill on hover */
    .cs-feel-card__btn:hover {
      background: rgba(10, 24, 10, 1) !important;
      color: #fff !important;
    }

    /* dark bg buttons — white fill on hover */
    .nb-form-wrap .dt-sc-newsletter-form .contact-input .dt-sc-btn:hover {
      background: rgba(255,255,255,0.15) !important;
      color: #fff !important;
    }

    /* ── Add to Cart button shimmer ── */
    .cs_coll_card_add_to_cart--shimmer {
      position: relative;
      overflow: hidden;
    }
    .cs_coll_card_add_to_cart--shimmer::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 60%;
      height: 100%;
      background: linear-gradient(120deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%);
      transition: left 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .cs_coll_card_add_to_cart--shimmer:hover::before {
      left: 160%;
    }
  `;
  document.head.appendChild(style);

  /* ── IntersectionObserver for scroll animations ── */
  function initAnimations() {
    var els = document.querySelectorAll('[data-gs-anim]');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('gs-animated');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }

})();
